module.exports = __webpack_public_path__ + "static/img/coupon.dae3897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon.png
// module id = EQFt
// module chunks = 1